
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, mapValues, isEqual } from 'lodash';
import { useDispatch } from '../../common/react-redux-hooks';
import openedArrow from '../../../images/Autocode/arrow_opened.svg';
import closedArrow from '../../../images/Autocode/arrow_closed.svg';
import greyEclipse from '../../../images/Autocode/grey_eclipse.svg';
import blueEclipse from '../../../images/Autocode/blue_eclipse.svg';
import close from '../../../images/Autocode/close.svg';
import AutocodeSelectionAction from './AutocodeSelectionActions';
import { useACSelectionBoxContext } from '../ACContext/ACSelectionBoxContext';

export const AutocodeLabelSelectorDropDown = props => {

  const moduleAction = props.moduleAction;
  const acSelContext = useACSelectionBoxContext();
  const { setSelectedLabelType } = AutocodeSelectionAction(acSelContext.state, acSelContext.dispatch);

  const [labelArrow, setLabelArrow] = useState(closedArrow);

  const partsToShow =
    acSelContext && acSelContext.state && acSelContext.state.partsToShow
      ? acSelContext.state.partsToShow
      : {
          showCat: false,
          showSCats: false,
          showQ: true,
          showA: true,
        };

  const [autoCodelabelConfig, setAutoCodelabelConfig] = useState(partsToShow);
  const [oldAutocodeLabelConfig, setOldAutocodeLabelConfig] = useState(partsToShow);
  const setLabelTitle = labelConfig => {
    let title = '';
    if (labelConfig.showA && !labelConfig.showCat && !labelConfig.showSCats && !labelConfig.showQ) {
      title = 'Answer Labels';
    } else if (labelConfig.showA && labelConfig.showCat && labelConfig.showSCats && labelConfig.showQ) {
      title = 'Full Labels';
    } else {
      title = 'Custom Labels';
    }

    return title;
  };
  const [selectedLabel, setSelectedLabel] = useState(setLabelTitle(partsToShow));
  const dispatch = useDispatch();

  const setLabelConfig = (labelName, subLabel) => {
    let newAutoCodelabelConfig = cloneDeep(autoCodelabelConfig);
    if (labelName === 'Answer') {
      newAutoCodelabelConfig = {
        showCat: false,
        showSCats: false,
        showQ: false,
        showA: true,
      };
      setSelectedLabel(setLabelTitle(newAutoCodelabelConfig));
      setOldAutocodeLabelConfig(newAutoCodelabelConfig);

    } else if (labelName === 'Full') {
      newAutoCodelabelConfig = {
        showCat: true,
        showSCats: true,
        showQ: true,
        showA: true,
      };
      setSelectedLabel(setLabelTitle(newAutoCodelabelConfig));
      setOldAutocodeLabelConfig(newAutoCodelabelConfig);

    } else if (labelName === 'Custom') {
      let customObj = newAutoCodelabelConfig;

      if (subLabel === 'Category') {
        if (autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
          && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) {

          customObj = mapValues(customObj, () => false);
          customObj.showA = true;
          customObj.showCat = true;
        } else if (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
          && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) {
          customObj = mapValues(customObj, () => true);
        } else {
          customObj.showCat = true;
        }
      } else if (subLabel === 'Subcategory') {

        if (autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
          && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) {

          customObj = mapValues(customObj, () => false);
          customObj.showA = true;
          customObj.showSCats = true;

        } else if (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
          && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) {

          customObj = mapValues(customObj, () => true);
        } else {
          customObj.showSCats = true;
        }
      } else if (subLabel === 'Question') {
        if (autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
          && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) {

          customObj = mapValues(customObj, () => false);
          customObj.showQ = true;
          customObj.showA = true;

        } else if (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
          && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) {

          customObj = mapValues(customObj, () => true);
        } else {
          customObj.showQ = true;
        }
      } else if (subLabel === 'Answer') {
        if (autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
          && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) {

          customObj = mapValues(customObj, () => false);
          customObj.showA = true;
        } else if (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
          && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) {

          customObj = mapValues(customObj, () => true);
        } else {
          customObj.showA = true;
        }
      } else if (autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
        && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) {

        customObj = mapValues(customObj, () => false);
        customObj.showA = true;
      } else if (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
          && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) {
        customObj = mapValues(customObj, () => true);
      }

      newAutoCodelabelConfig = customObj;
    }
    if (!isEqual(newAutoCodelabelConfig, autoCodelabelConfig)) {
      setAutoCodelabelConfig({ ...newAutoCodelabelConfig });

      if (labelName === 'Answer' || labelName === 'Full') {
        setSelectedLabelType(newAutoCodelabelConfig);
        dispatch(moduleAction.setLabelTypeAC(newAutoCodelabelConfig));
        if (labelArrow === openedArrow) {
          setLabelArrow(closedArrow);
        } else {
          setLabelArrow(openedArrow);
        }
      }
    }
  };

  const removeSubItems = subItem => {
    const newAutoCodelabelConfig = cloneDeep(autoCodelabelConfig);
    if (newAutoCodelabelConfig) {
      if (
        subItem === 'Category' &&
        (newAutoCodelabelConfig.showSCats ||
          newAutoCodelabelConfig.showQ ||
          newAutoCodelabelConfig.showA)
      ) {
        newAutoCodelabelConfig.showCat = false;
      } else if (
        subItem === 'Subcategory' &&
        (newAutoCodelabelConfig.showCat ||
          newAutoCodelabelConfig.showQ ||
          newAutoCodelabelConfig.showA)
      ) {
        newAutoCodelabelConfig.showSCats = false;
      } else if (
        subItem === 'Question' &&
        (newAutoCodelabelConfig.showCat ||
          newAutoCodelabelConfig.showSCats ||
          newAutoCodelabelConfig.showA)
      ) {
        newAutoCodelabelConfig.showQ = false;
      } else if (
        subItem === 'Answer' &&
        (newAutoCodelabelConfig.showCat ||
          newAutoCodelabelConfig.showSCats ||
          newAutoCodelabelConfig.showQ)
      ) {
        newAutoCodelabelConfig.showA = false;
      }
    }
    if (!isEqual(newAutoCodelabelConfig, autoCodelabelConfig)) {
      setAutoCodelabelConfig({ ...newAutoCodelabelConfig });
    }
  };

  const checkItemsSelected = subItem => {
    let itemSelectedFlag = false;
    if (autoCodelabelConfig && Object.keys(autoCodelabelConfig).length > 0) {
      if (subItem === 'Category' && autoCodelabelConfig.showCat) {
        itemSelectedFlag = true;
      } else if (subItem === 'Subcategory' && autoCodelabelConfig.showSCats) {
        itemSelectedFlag = true;
      } else if (subItem === 'Question' && autoCodelabelConfig.showQ) {
        itemSelectedFlag = true;
      } else if (subItem === 'Answer' && autoCodelabelConfig.showA) {
        itemSelectedFlag = true;
      }

      if (!itemSelectedFlag) {
        if (subItem === 'Answer' && (
          (autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
            && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) 
          || 
          (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
            && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ))) {
          itemSelectedFlag = true;
        } else if (subItem === 'Subcategory' && (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
          && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ)) {
          itemSelectedFlag = true;
        } else if (subItem === 'Question' && (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
          && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ)) {
          itemSelectedFlag = true;
        } else if (subItem === 'Category' && (autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
          && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ)) {
          itemSelectedFlag = true;
        }
      }
    }
    return itemSelectedFlag;
  };

  const applyButtonSelection = () => {
    let applyButtonClass = '';
    if (
      autoCodelabelConfig.showCat ||
      autoCodelabelConfig.showSCats ||
      autoCodelabelConfig.showQ ||
      autoCodelabelConfig.showA
    ) {
      applyButtonClass = 'apply-enabled';
    } else {
      applyButtonClass = 'apply-disabled';
    }
    return applyButtonClass;
  };

  return (
    <Fragment>
      <div className="label-selector-main">
        <button
          type="button"
          className="label-selector"
          onClick={() => {
            if (labelArrow === openedArrow) {
              setLabelArrow(closedArrow);
              setAutoCodelabelConfig(oldAutocodeLabelConfig);
            } else {
              setLabelArrow(openedArrow);
            }
          }}
        >
          <span>{selectedLabel}</span>
          <img className="autocode-label-selector" src={openedArrow} alt="label arrow" />
        </button>
        {labelArrow === openedArrow && (
          <div className="label-selector-panel">
            <div
              style={{
                fontWeight: `${(autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
                  && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) ? 'bold' : 'normal'}`,
                marginBottom: '10px',
              }}
              onClick={() => setLabelConfig('Answer')}
            >
              <span className="label-selector-items">
                <img alt="Answer Label Eclipse" src={(autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
            && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) ? blueEclipse : greyEclipse} />{' '}
                Answer Label
              </span>
            </div>
            <div
              style={{
                fontWeight: `${(autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
                  && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) ? 'bold' : 'normal'}`,
                marginBottom: '10px',
              }}
              onClick={() => setLabelConfig('Full')}
            >
              <span className="label-selector-items">
                <img alt="Full Label Eclipse" src={(autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
                && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) ? blueEclipse : greyEclipse} /> Full
                Label
              </span>
            </div>
            <div>
              <div
                style={{
                  fontWeight: `${!(autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
                    && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) 
                    && !(autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
                      && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) ? 'bold' : 'normal'}`,
                  marginBottom: '10px',
                }}
                onClick={() => setLabelConfig('Custom')}
              >
                <span className="label-selector-items">
                  <img
                    alt="Custom Label Eclipse"
                    src={!(autoCodelabelConfig.showA && autoCodelabelConfig.showCat 
                      && autoCodelabelConfig.showSCats && autoCodelabelConfig.showQ) 
                      && !(autoCodelabelConfig.showA && !autoCodelabelConfig.showCat 
                        && !autoCodelabelConfig.showSCats && !autoCodelabelConfig.showQ) ? blueEclipse : greyEclipse}
                  />{' '}
                  Custom Label
                </span>
              </div>
              <div>
                <div>
                  <span
                    onClick={() => setLabelConfig('Custom', 'Category')}
                    className={`label-selector-sub-items ${checkItemsSelected('Category') ? 'sub-items-selected' : ''}`}
                  >
                    Category
                    {checkItemsSelected('Category') && (
                      <img
                        src={close}
                        alt="Remove Category"
                        onClick={() => removeSubItems('Category')}
                        className="label-img"
                      />
                    )}
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => setLabelConfig('Custom', 'Subcategory')}
                    className={`label-selector-sub-items ${
                      checkItemsSelected('Subcategory') ? 'sub-items-selected' : ''
                    }`}
                  >
                    Subcategory
                    {checkItemsSelected('Subcategory') && (
                      <img
                        src={close}
                        alt="Remove Subcategory"
                        onClick={() => removeSubItems('Subcategory')}
                        className="label-img"
                      />
                    )}
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => setLabelConfig('Custom', 'Question')}
                    className={`label-selector-sub-items ${checkItemsSelected('Question') ? 'sub-items-selected' : ''}`}
                  >
                    Question
                    {checkItemsSelected('Question') && (
                      <img
                        src={close}
                        alt="Remove Question"
                        onClick={() => removeSubItems('Question')}
                        className="label-img"
                      />
                    )}
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => setLabelConfig('Custom', 'Answer')}
                    className={`label-selector-sub-items ${checkItemsSelected('Answer') ? 'sub-items-selected' : ''}`}
                  >
                    Answer
                    {checkItemsSelected('Answer') && (
                      <img
                        src={close}
                        alt="Remove Answer"
                        onClick={() => removeSubItems('Answer')}
                        className="label-img"
                      />
                    )}
                  </span>
                </div>
                <div>
                  <button
                    type="button"
                    className={`label-selector-apply ${applyButtonSelection('Apply')}`}
                    onClick={() => {
                      setSelectedLabelType(autoCodelabelConfig);
                      setSelectedLabel(setLabelTitle(autoCodelabelConfig));
                      setOldAutocodeLabelConfig(autoCodelabelConfig);
                      dispatch(moduleAction.setLabelTypeAC(autoCodelabelConfig));
                      if (labelArrow === openedArrow) {
                        setLabelArrow(closedArrow);
                      } else {
                        setLabelArrow(openedArrow);
                      }
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

AutocodeLabelSelectorDropDown.propTypes = {
  moduleStudy: PropTypes.shape({
    st: PropTypes.string,
    ss: PropTypes.string,
    pn: PropTypes.number,
  }),
  selectedWeightType: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  moduleAction: PropTypes.shape({
    setLabelTypeAC: PropTypes.func,
  }),
};
